function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-11.000000, -7.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(12.000000, 8.000000)"
}, React.createElement("g", {
  id: "Group-2",
  fill: "#52606D",
  fillRule: "nonzero",
  stroke: "#52606D"
}, React.createElement("path", {
  d: "M8.5,27 C8.6211253,27.6666667 8.71196928,28 8.77253193,28 C9.0757015,28 9.49858473,28 10.0411816,28 C10.1374846,28 10.2904241,27.6666667 10.5,27 C16.2432323,21.7375464 19,16.2074122 19,12 C19,5.372583 14.7467051,0 9.5,0 C4.25329488,0 0,5.372583 0,12 C0,16.418278 2.83333333,21.418278 8.5,27 Z",
  id: "Oval"
})), React.createElement("g", {
  id: "Group-2-Copy",
  transform: "translate(19.326352, 20.484808) rotate(10.000000) translate(-19.326352, -20.484808) translate(9.826352, 1.984808)"
}), React.createElement("path", {
  d: "M19.0526316,28.0714286 C19.1673819,28.6904762 19.2534446,29 19.3108197,29 C19.598033,29 19.9986592,29 20.5126984,29 C20.6039328,29 20.7488228,28.6904762 20.9473684,28.0714286 C26.3883254,23.1848645 29,18.0497399 29,14.1428571 C29,7.98882707 24.9705627,3 20,3 C15.0294373,3 11,7.98882707 11,14.1428571 C11,18.2455439 13.6842105,22.888401 19.0526316,28.0714286 Z",
  id: "Oval",
  stroke: "#CBD2D9",
  fill: "#CBD2D9",
  fillRule: "nonzero",
  transform: "translate(20.000000, 16.000000) rotate(10.000000) translate(-20.000000, -16.000000) "
}), React.createElement("path", {
  d: "M16.951237,28 C17.3644902,33.1347123 15.0449049,33 14,38",
  id: "Path",
  stroke: "#CBD2D9",
  fillRule: "nonzero",
  transform: "translate(15.500000, 33.000000) rotate(10.000000) translate(-15.500000, -33.000000) "
}), React.createElement("path", {
  d: "M9.421795,28.1651692 C9.90093908,33.6257931 13.4132453,34.2382633 13.155187,38.7998914",
  id: "Path",
  stroke: "#52606D",
  fillRule: "nonzero"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 31 40",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/LogoB.8c07ff67.svg";
export { SvgComponent as ReactComponent };